/** The only rollout list. Add data here after authoring/review, never a renderer fork.
 * Disabled and unknown locations retain their existing forecast visualiser. */
export type ExplorerLocation = {
  slug: string;
  name: string;
  type: 'surf' | 'sailing';
  timezone: string;
  packageVersion: string;
  rollout: 'disabled' | 'pilot' | 'ready';
  image: string;
  imageAlt?: string;
  geographyDescription: string;
  uncertainty: string;
};
export const BEACH_LOCATIONS: Readonly<Record<string, ExplorerLocation>> = {
  gwithian: {
    slug: 'gwithian', name: 'Gwithian', type: 'surf', timezone: 'Europe/London', packageVersion: 'v1', rollout: 'ready',
    image: '/images/beach-explorer/gwithian-explorer.png',
    imageAlt: '3D preview of Gwithian beach, dunes and Godrevy Island',
    geographyDescription: 'The coast uses Environment Agency LiDAR, mapped shore and habitats, and interpreted Sunset Surf, Jam Pot and distant Godrevy forms.',
    uncertainty: 'The sea is shown at a fixed illustrative 0 m ODN, without tide calibration or bathymetry. Intertidal returns and historical dune shape remain uncertain; the distant Godrevy context is simplified and has documented shoreline gaps.',
  },
  kimmeridge: {
    slug: 'kimmeridge', name: 'Kimmeridge Bay', type: 'surf', timezone: 'Europe/London', packageVersion: 'v1', rollout: 'ready',
    image: '/images/beach-explorer/kimmeridge-explorer.jpg',
    geographyDescription: 'The bay uses Environment Agency LiDAR and mapped OpenStreetMap coastline and rock shelves. Clavell Tower and the visitor centre use mapped footprints and interpreted exteriors.',
    uncertainty: 'Marine depth and tide calibration are unavailable. Intertidal rock elevations, mapped alignment and architectural details remain provisional. Water is shown at a fixed reference level.',
  },
  polzeath: {
    slug: 'polzeath', name: 'Polzeath', type: 'surf', timezone: 'Europe/London', packageVersion: 'v2', rollout: 'pilot',
    image: '/images/locations/polzeath.jpg',
    geographyDescription: 'The beach uses Environment Agency LiDAR and OpenStreetMap footprints, with distinctive buildings modelled from photographs.',
    uncertainty: 'The regional tide estimate uses Port Isaac harmonic data. Underwater terrain, sandbanks and local breaking waves remain approximate.',
  },
};
export function beachLocation(slug: string): ExplorerLocation | null {
  return Object.hasOwn(BEACH_LOCATIONS, slug) ? BEACH_LOCATIONS[slug] : null;
}
export function manifestPath(site: Pick<ExplorerLocation, 'slug' | 'packageVersion'>): string {
  if (!/^[a-z0-9-]{1,40}$/.test(site.slug) || !/^v\d+$/.test(site.packageVersion)) throw new Error('Invalid location identity');
  return `/beach-explorer/${site.slug}/${site.packageVersion}/manifest.json`;
}
